export default __webpack_public_path__ + "static/media/ei.eba121e2.svg";